module.exports = __webpack_public_path__ + "img/banner.2e761f2b.jpg";